import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, FilePlus2, Banknote, Receipt, CreditCard, UserPlus, Store } from 'lucide-react';

const ACTIONS = [
  { label: 'Create Invoice', path: '/invoices/new', icon: FilePlus2 },
  { label: 'Receive Payment', path: '/payments/new', icon: Banknote },
  { label: 'Enter Bill', path: '/bills/new', icon: Receipt },
  { label: 'Record Expense', path: '/expenses/new', icon: CreditCard },
  { label: 'New Customer', path: '/customers/new', icon: UserPlus },
  { label: 'New Vendor', path: '/vendors/new', icon: Store },
];

/**
 * QUICK ACTIONS — collapsible status panel with one-click entry points
 * into the most common daily workflows.
 */
export default function QuickActionsPanel() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  return (
    <section className="desk-status-section">
      <button type="button" className={`desk-status-toggle ${open ? '' : 'collapsed'}`} onClick={() => setOpen(o => !o)}>
        <ChevronDown /> Quick Actions
      </button>
      {open && (
        <div className="desk-status-body">
          {ACTIONS.map(a => (
            <button key={a.label} type="button" className="desk-quickaction" onClick={() => navigate(a.path)}>
              <a.icon /> {a.label}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
